import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { CompanyService } from '@app/core/services/company/company.service';
import { FormsModule } from '@angular/forms';
import { IonSearchbar } from '@ionic/angular/standalone';

@Component({
	selector: 'app-search-mobile',
	templateUrl: './search-mobile.component.html',
	styleUrls: ['./search-mobile.component.scss'],
	standalone: true,
	imports: [FormsModule, IonSearchbar],
})
export class SearchMobileComponent implements OnInit {
	company: string = '';
	constructor(
		private router: Router,

		private companyService: CompanyService,
	) {}

	ngOnInit() {}

	search(event: any) {
		if (!this.company) return;

		const navigationExtras: NavigationExtras = {
			skipLocationChange: false,
		};

		this.companyService.reloadCompanies(this.company);

		this.router.navigateByUrl(
			'/search-companies?name=' + this.company,
			navigationExtras,
		);
	}
}
